import React from 'react';
import { InView } from 'react-intersection-observer';
import { TimeslotsList, TimeslotsMap } from 'entities/toolbar/timeslots';
import { TimeslotsListScrollProps } from '../lib/timeslots/types';

const TimeslotsListScroll: React.FC<TimeslotsListScrollProps> = ({
	timeslots,
	enableSlotUpdatesHandler,
	selectSlot,
}) => {
	return (
		<>
			<InView
				as="div"
				style={{ padding: '2px' }}
				onChange={(inView, _) =>
					enableSlotUpdatesHandler({ first: inView })
				}
			/>
			{timeslots.map((item: TimeslotsMap, index) => (
				<TimeslotsList
					time={item[0]}
					slots={item[1]}
					selectSlot={selectSlot}
					key={item[0]}
					isLast={timeslots.length - 1 === index}
				/>
			))}
			<InView
				as="div"
				style={{ padding: '2px' }}
				onChange={(inView, _) =>
					enableSlotUpdatesHandler({ last: inView })
				}
			/>
		</>
	);
};

export default TimeslotsListScroll;
